/* eslint-disable */
import {pick} from "lodash";

export default function resourceProviderConfig($resourceProvider) {

    "ngInject";

    $resourceProvider.defaults = {
        stripTrailingSlashes: false,
        actions: {
            query: {
                method: 'GET',
                isArray: true,
                transformResponse: function (data, headersGetter, status) {
                    if (data) {
                        data = JSON.parse(data);
                        if (data && data.results) {
                            let result = data.results;
                            result._meta = pick(data, ["count", "next", "previous", "page", "page_count"]);
                            result._meta.status = status;
                            return result;
                        } else if (data && data.length) {
                            return data;
                        }
                    }
                    let result = [];
                    result._meta = {count: 0, next: null, previous: null, status: status, page: 1, page_count: 1};
                    return result;
                }
            },
            get: {
                method: 'GET',
                isArray: false,
                transformResponse: (data) => JSON.parse(data)
            },
            create: {
                method: 'POST',
                transformResponse: (data) => JSON.parse(data)
            },
            update: {
                method: 'PUT',
                transformResponse: (data) => JSON.parse(data)
            },
            delete: {
                method: 'DELETE',
                transformResponse: (data) => null
            }
        }
    }
}


// WEBPACK FOOTER //
// ./sources/config/resourceProvider.config.js